<template>
  <div class="activity-log" v-if="logs">
    <v-list class="logs">
      <div class="logs-timeline" />

      <v-list-group
        v-for="(log, index) in logs"
        :key="index"
        @input="log.active = $event"
      >
        <v-list-tile avatar slot="activator" class="item-header">
          <v-list-tile-avatar size="24" style="min-width: 30px">
            <v-img v-if="log.user.avatar && log.user.avatar.url !== null" :src="log.user.avatar.url" />
            <span v-else>{{ acronym(log.user.name) }}</span>
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title class="custom-tile">
              <span>{{ startCaseText(log.user.name) }}</span>
            </v-list-tile-title>
          </v-list-tile-content>

          <v-list-tile-action
            class="pl-1 grey--text text--darken-1"
            style="font-size: 10px;"
          >
            {{ formatDate(log.logs[0].created_at) }} - {{ formatDate(log.logs[log.logs.length - 1].created_at) }}
          </v-list-tile-action>

        </v-list-tile>
        <v-list-tile
          avatar
          v-for="(activity, index) in log.logs"
          :key="activity.id"
          class="py-1 subitem-description"
        >
          <v-list-tile-avatar size="24" class="mt-1 circles" style="min-width: 30px"
            :class="index === 0 || index === log.logs.length - 1 ?  'outline' : 'fill'">
            <v-icon size="8" style="background: white; height: 8px">
              {{ index === 0 || index === log.logs.length - 1 ?  'mdi mdi-circle-outline' : 'mdi mdi-circle'}}
            </v-icon>
          </v-list-tile-avatar>

          <v-menu open-on-hover top :close-on-content-click="false">
            <v-layout
              slot="activator"
              justify-start
              column
              fill-height
              class="pr-2"
            >
              <span class="text-truncate" style="font-size: 14px; width: 320px" v-clampy="2">
                {{ activity.description }}
              </span>

              <v-layout align-center pt-1 class="caption" style="width: 325px;" v-if="activity.document_type_name">
                <v-icon size="18">mdi mdi-file-document</v-icon>
                <span class="text-truncate">{{activity.document_type_name}}</span>
              </v-layout>
            </v-layout>
            <activity-detail-card :log="log" :activity="activity" />

          </v-menu>
        </v-list-tile>
      </v-list-group>
    </v-list>
  </div>
</template>

<script>
import { capitalize, startCase, lowerCase, groupBy, truncate } from 'lodash';
import format from 'date-fns/format';
import * as ptLocale from 'date-fns/locale/pt';
import acronym from '@/utils/acronym';
import ActivityDetailCard from '@/components/folder/activity-log/ActivityDetailCard';

export default {
  name: 'activity-log',
  components: {
    ActivityDetailCard,
  },
  methods: {
    capitalizeText(string) {
      return capitalize(string);
    },
    startCaseText(string) {
      return startCase(lowerCase(string));
    },
    formatDateMonth(date) {
      const day = format(date, 'DD');
      const month = format(date, 'MMMM', { locale: ptLocale });
      return `${day} de ${capitalize(month)}`;
    },
    formatDate(date) {
      return format(date, 'DD/MM/YY');
    },
    acronym(string) {
      return acronym(string);
    },
    logsGroupedByDate(logs) {
      const groupedLogs = groupBy(logs, item => this.formatDateMonth(item.created_at));
      return groupedLogs;
    },
    truncateString(string) {
      return truncate(string, { length: 24, omission: '...' });
    },
  },
  computed: {
    logs() {
      return this.$store.getters.activeFolder.activity_logs;
    },
    logsWithoutFirstItem() {
      const logs = this.logs.slice(1);
      return logs;
    },
  },
};
</script>

<style lang="scss" scoped>
  .v-image{
    background: #9e9e9e !important;
  }
  .activity-log {
    width: 410px !important;
    overflow-y: auto;
    padding: 3px;
    .item-header {
      .v-avatar {
        position: relative;
        z-index: 1;
        box-shadow: 0 0 0 8px #fff;
      }
      &:hover {
        .v-avatar {
          box-shadow: 0 0 0 8px #f5f5f5;
        }
      }
    }
    .custom-tile {
      width: 180px;
      z-index: 2;
      position: relative;
      font-size: 14px;
    }
    .v-list__tile {
      padding: 0 8px;
    }
    .log-deadline {
      font-size: 14px;
    }
    .circles {
      align-self: flex-start;

      &.fill {
        .v-icon {
          font-size: 6px !important;

          &:before {
            border: 2px solid #fff;
            border-radius: 50%;
          }
        }
      }
    }
    .date {
      font-size: 12px;
      align-items: flex-start;
      line-height: 2.5;
    }
    .time {
      font-size: 12px;
    }
    .subitem-description {
      position: relative;

    }
    .v-list__group::before {
      display: none;
    }
    .v-list__group::after {
      display: none;
    }
    .log-icon {
      margin-right: 20px;
      max-width: 8px;
      max-height: 8px;
    }
    .custom-divider {
      margin-left: 65px;
    }
    .card-timeline {
      width: 0px;
      border: 1px solid rgba(0,0,0,.08);
      position: absolute;
      top: 72px;
      left: 19px;
      height: calc(100% - 128px);
    }
    .logs {
      position: relative;
    }
    .logs-timeline {
      width: 0;
      border: 1px solid rgba(0,0,0,.08);
      position: absolute;
      top: 10px;
      left: 26px;
      height: calc(100% - 66px);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/folder/activity-log/FolderActivityLog.vue